module.exports = __webpack_public_path__ + "static/img/payments.b515499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/logo/payments.png
// module id = 708
// module chunks = 2